// Safe access to environment variables
interface ImportMetaEnv {
    VITE_REVALIDATION_API_KEY?: string;
    VITE_SANITY_PROJECT_ID?: string;
    VITE_SANITY_DATASET?: string;
    VITE_DRAFT_MODE_SECRET?: string;
    VITE_API_URL?: string;
    // Add other environment variables as needed
}

const env: ImportMetaEnv = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {};

export const revalidationApiKey = env.VITE_REVALIDATION_API_KEY || '';
export const sanityProjectId = env.VITE_SANITY_PROJECT_ID || 'psdfhal0';
export const sanityDataset = env.VITE_SANITY_DATASET || 'production';
export const draftModeSecret = env.VITE_DRAFT_MODE_SECRET || '';
export const apiUrl = env.VITE_API_URL;
